import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify'; // <-- Import toast
import '../../styles/AuthForm.css';
import CustomButton from '../../components/CustomButton';
import RightComponent from './RightSideComponent';
import logo from '../../images/logo.png';
import { Link } from 'react-router-dom';
import Typography from '../../components/Typography';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/forgot-password`, { email });
            toast.success(response.data.message || 'Reset link sent successfully');
        } catch (error) {
            toast.error(error.response?.data?.message || 'Something went wrong');
        }
    };

    return (
        <div className='grid grid-cols-7 relative min-h-screen' >
            <Link to={'/'}className='lg:left-9 left-1/2 transform -translate-x-1/2 lg:translate-x-0 ' style={{ position: 'absolute', top: '36px',}}><img src={logo} alt='logo'  /></Link> 
            <Link to={'/login'} style={{ position: 'absolute', top: '126px', left: '36px' }} className='flex' ><Typography className='mr-1' text={'<'} family={'Supply'} color={'#DF0F11'} size={'18.462px'} transform={'uppercase'} weight={400} lineheight={'130%'} /> <Typography family={'Supply'} text={'GO BACK'} color={'#FFFFFF'} size={'18.462px'} transform={'uppercase'} weight={400} lineheight={'130%'} /></Link> 
            <div className='lg:col-span-4 col-span-7 px-4  flex justify-center items-center h-screen  bg-[#0F0F0F] text-center lg:text-left'>
                <div className="py-48 mx-auto w-[464px]">
                    <div className='auth-header text-center lg:text-left'>Forgot Pass</div>
                    <div className='auth-desc'>Enter your email to receive a password reset link.</div>
                    <form className="" onSubmit={handleSubmit}>
                        <div className="relative z-0 w-full mb-5 group mt-10">
                            <input type="email" name="email" placeholder="Email" id="email" className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 placeholder-white/40"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required />
                        </div>

                        <CustomButton type='submit' className='mt-8' text={'RESET PASSWORD'} />
                    </form>
                </div>
            </div>
            <div className="lg:col-span-3 lg:flex hidden">
                <RightComponent />
            </div>
        </div>
    );
};

export default ForgotPassword;